import React, { useEffect, useState } from 'react';
import useTranslation from '../../hooks/useTranslation';
import './tableStyle.css';
import Notification from '../Notification/Notification';
import FetchLoading from "../Loading/FetchLoading";
import Loading from "../Loading";

/**
 * 로그 페이지 등에서 사용할 테이블 컴포넌트
 *
 * 스키마에 정의된 데이터로 테이블을 작성한다.
 *
 * 스키마 참고: useSchemaLoginLog.jsx 참고
 *
 * maxHeight: 테이블의 최대 높이(페이지마다 다르게 설정 가능. default 수정은 tableStyle.css에서)
 *
 * @param {{schema: object, rows: object[], loading: boolean, onClick: function(), className: string, maxHeight : string}} param
 * @returns
 */
const BOTable = ({ schema, rows, loading, onClick, className, maxHeight }) => {
  const { t } = useTranslation();

  const [headKey, setHeadKey] = useState([]);
  const [head, setHead] = useState([]);
  const [body, setBody] = useState();
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');

  function handleTDClick(content) {
    let textToCopy = '';

    // string | number 인 경우
    if (typeof content === 'string' || typeof content === 'number') {
      textToCopy = content.toString().trim();
    }

    // a 태그인 경우
    if (
      content?.$$typeof?.toString() === 'Symbol(react.element)' &&
      content.props?.href
    ) {
      textToCopy = content.props?.href.toString().trim();
    }
    // 이미지인 경우
    else if (
      content?.$$typeof?.toString() === 'Symbol(react.element)' &&
      content.props.children.props.src
    ) {
      textToCopy = content.props?.children.props.src.toString().trim();
    }

    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        if (textToCopy) {
          setNotificationMessage(`${textToCopy.startsWith("http") ? "URL " : ""}복사 성공!\n${textToCopy}`);
        } else {
          setNotificationMessage(`복사할 수 없습니다.`);
          console.log(textToCopy);
        }
        setShowNotification(true);
      })
      .catch((err) => {
        console.error('복사 실패:', err);
      });
  }

  useEffect(() => {
    setHead(schema?.head || []);
    setHeadKey(schema?.headKey || []);
  }, [schema]);

  useEffect(() => {
    if (rows && schema) {
      setBody(schema?.body(rows));
    }
  }, [schema, rows]);

  const layoutBody = () => {
    if (loading) {
      return (
        <tr>
          <td
            colSpan={head.length}
            style={{ textAlign: 'center', backgroundColor: '#FAFBFC' }}
          >
            {/*{t('table.loading')}*/}
            <FetchLoading/>
          </td>
        </tr>
      );
    }

    if (body && body.length > 0) {
      return body.map((row) => (
        <tr
          key={row.key}
          onClick={() => {
            if (onClick) {
              onClick(row);
            }
          }}
        >
          {headKey.map((e) => (
            <td className={`td-${e}`} key={e}>
              <div className="td-item">
                <div className="td-text">{row[e]}</div>
                <button
                  className="table-row-copyBtn"
                  onClick={(event) => {
                    event.stopPropagation();
                    handleTDClick(row[e]);
                  }}
                >
                  복사
                </button>
              </div>
            </td>
          ))}
        </tr>
      ));
    }

    return (
      <tr>
        <td
          colSpan={head.length}
          style={{ textAlign: 'center', height: '50px' }}
        >
          {/*{t('table.log.empty')}*/}
          <div style={{padding : "50px", fontSize : "14px", }}>
            등록된 로그 정보가 없습니다.
          </div>
        </td>
      </tr>
    );
  };

  return (
    <div className="table-container" style={{ maxHeight: maxHeight }}>
      <table className={`${className} `}>
        <thead>
          <tr>
            {head.map((i, index) => (
              <th key={index} className="">
                {i}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{layoutBody()}</tbody>
      </table>
      {showNotification ? (
        <Notification
          close={() => setShowNotification(false)}
          message={notificationMessage}
        />
      ) : null}
    </div>
  );
};

export default BOTable;
